import { render, staticRenderFns } from "./RestrictionDialog.vue?vue&type=template&id=24837e0e&scoped=true&lang=pug&"
import script from "./RestrictionDialog.vue?vue&type=script&lang=ts&"
export * from "./RestrictionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RestrictionDialog.vue?vue&type=style&index=0&id=24837e0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24837e0e",
  null
  
)

export default component.exports